import { render, staticRenderFns } from "./SingleFieldForm.vue?vue&type=template&id=5522a53f&scoped=true&name=single-field-form&"
import script from "./SingleFieldForm.vue?vue&type=script&lang=js&"
export * from "./SingleFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./SingleFieldForm.vue?vue&type=style&index=0&id=5522a53f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522a53f",
  null
  
)

export default component.exports